var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormInputContainer',{staticClass:"FormPasswordInput",attrs:{"inputId":`I${_vm._uid}`,"label":_vm.label,"errors":_vm.errors,"required":_vm.required}},[_c('input',_vm._g({attrs:{"id":`I${_vm._uid}`,"type":"password","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.value}},{ [_vm.lazy ? 'change' : 'input']: _vm.handleInput }))])
}
var staticRenderFns = []

export { render, staticRenderFns }